/**
 * Construcciones Remalex S.L. — Logo Component
 * Recreates the official logo: orange pillar icon + company name + tagline
 *
 * Props:
 *   variant: "light" (green text, on white bg) | "dark" (white text, on green bg) | "white" (all white)
 *   size:    "sm" | "md" | "lg"
 *   showTagline: boolean (default true)
 */

const sizes = {
  sm: { icon: 28, name: 'text-base',  tagline: 'text-[8px]',  gap: 'gap-2' },
  md: { icon: 36, name: 'text-lg',    tagline: 'text-[9px]',  gap: 'gap-2.5' },
  lg: { icon: 48, name: 'text-2xl',   tagline: 'text-[11px]', gap: 'gap-3' },
};

const Logo = ({ variant = 'light', size = 'md', showTagline = true }) => {
  const s = sizes[size] || sizes.md;

  const nameColor =
    variant === 'light' ? '#006039' :
    variant === 'dark'  ? '#FFFFFF' :
    '#FFFFFF';

  const taglineColor =
    variant === 'light' ? 'rgba(0,96,57,0.6)' :
    variant === 'dark'  ? 'rgba(255,255,255,0.6)' :
    'rgba(255,255,255,0.6)';

  // Icon: 5 vertical orange pillars arranged in an arch (tallest center)
  const barWidth  = 5.5;
  const barGap    = 3.5;
  const bars = [
    { h: 0.50 }, // leftmost — shortest
    { h: 0.73 },
    { h: 1.00 }, // center — tallest
    { h: 0.73 },
    { h: 0.50 }, // rightmost — shortest
  ];
  const totalW = bars.length * barWidth + (bars.length - 1) * barGap; // 43
  const totalH = s.icon;

  return (
    <div className={`flex items-center ${s.gap}`} style={{ userSelect: 'none' }}>
      {/* Pillar icon */}
      <svg
        width={totalW * (s.icon / totalH)}
        height={s.icon}
        viewBox={`0 0 ${totalW} ${totalH}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {bars.map((bar, i) => {
          const x = i * (barWidth + barGap);
          const h = bar.h * totalH;
          const y = totalH - h;
          return (
            <rect
              key={i}
              x={x}
              y={y}
              width={barWidth}
              height={h}
              rx={1}
              fill="#E87722"
            />
          );
        })}
      </svg>

      {/* Text block */}
      <div className="flex flex-col leading-none">
        <span
          className={`font-heading font-normal tracking-tight leading-none ${s.name}`}
          style={{ color: nameColor }}
        >
          Construcciones Remalex S.L.
        </span>
        {showTagline && (
          <span
            className={`font-body uppercase tracking-[0.2em] mt-1 ${s.tagline}`}
            style={{ color: taglineColor }}
          >
            Construcción y renovación · Costa Brava
          </span>
        )}
      </div>
    </div>
  );
};

export default Logo;
